export const getGeneral = store => store.general
export const getGeneralVenue = store => store.general.venue
export const getGeneralCard = store => store.general.card
export const getGeneralSettings = store => store.general.settings
export const getGeneralLogin = store => store.general.login
export const getGeneralStats = store => store.general.stats
export const getSelectedLanguage = store => store.general.selectedLanguage
export const getBrandIntegrationStatus = store => store.general.brandIntegrationEnabled
